import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import { geoApi } from '../api/geoApi'

const includedPrimaryTypes = ['locality', 'sublocality']

export const useLocalityAutocompleteQuery = (value: string | undefined) => {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const { locale } = useIntl()

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), 200)
    return () => clearTimeout(timeout)
  }, [value])

  return useQuery({
    enabled: !!debouncedValue,
    queryKey: ['locality_autocomplete', debouncedValue, locale],
    queryFn: ({ signal }) =>
      // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- the query is enabled only if debouncedValue is defined
      geoApi.getAutocomplete({ input: debouncedValue!, includedPrimaryTypes, locale }, { signal }),
  })
}
